/**
 * Identifies which Google-for-Jobs auto-click-apply variant should fire on the
 * ViewJob page. Both string values correspond to `ReceivedFlagType` enum entries
 * on the mweb server, so they can be emitted directly as `mobRcvFlag` `flag`
 * field values without further translation.
 */
export type AutoClickApplyFlag = 'autoClickApplyIA' | 'autoClickApplyNonIA';

/**
 * Resolves which auto-click variant (if any) should fire from the server-set
 * booleans. Returns `null` when neither flag is set; IA takes precedence if
 * both happen to be truthy.
 */
export function getAutoClickApplyFlag(autoClickFlags: {
    autoClickApply?: boolean;
    autoClickApplyNonIa?: boolean;
}): AutoClickApplyFlag | null {
    if (autoClickFlags.autoClickApply) {
        return 'autoClickApplyIA';
    }
    if (autoClickFlags.autoClickApplyNonIa) {
        return 'autoClickApplyNonIA';
    }
    return null;
}
